import { useEffect, useRef, useState } from 'react';
import StaticPagination from 'ui/components/atoms/StaticPagination';
import TabsPromo from 'ui/components/atoms/TabsPromo';
import CardPromo from 'ui/components/molecules/CardPromo';
import promoPageView from 'ui/lib/gtm/promoPageView';
import { sendDataInChunks } from 'ui/lib/collectData';

const PromoListSection = ({
  categoryList,
  promoList,
  totalData,
  totalPages,
  paginationBaseUrl,
  page = null,
  pageSize,
  tabClassname,
  hasBanner,
  categoryEmarsys = '',
  feature = '',
  pageTitle = '',
  breadcrumbItems = [],
}: any) => {
  const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;

  const [collectDataLayer, setCollectDataLayer] = useState([]);
  const [isScrolled, setIsScrolled] = useState(false);

  const typingTimeout = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    clearTimeout(typingTimeout.current);
    typingTimeout.current = setTimeout(() => {
      if (collectDataLayer?.length > 0) {
        const sorted = collectDataLayer.sort((a, b) => {
          const positionA = parseInt(a.position.split(' ')[0]);
          const positionB = parseInt(b.position.split(' ')[0]);
          return positionA - positionB;
        });
        sendDataInChunks(
          sorted,
          4,
          (chunk) => {
            promoPageView(chunk);
          },
          setCollectDataLayer,
          ''
        );
      }
    }, 100);
  }, [collectDataLayer]);

  return (
    <section className="mt-4 mb-6 lg:my-8">
      <div className="lg:container xl:px-0">
        <TabsPromo
          tabs={categoryList}
          className={`${
            isScrolled ? 'border-b-2 border-reliableBlack10' : ''
          } sticky ${tabClassname}  z-20 bg-white lg:mb-6`}
        >
          {/* Card promo list */}
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 lg:gap-6">
            {promoList.map((promo, index) => {
              const category = promo?.contentCategory?.name?.toLowerCase().split(' ').join('-');
              const slug = promo?.slug;

              return (
                <CardPromo
                  key={promo?.id}
                  idPage={promo?.id}
                  title={promo?.titlePage}
                  slug={slug}
                  category={category}
                  href={
                    promo?.articleType === 'national'
                      ? `${PUBLIC_URL}/promosi/${category}/${slug}`
                      : null
                  }
                  startDate={promo?.startDate}
                  endDate={promo?.endDate}
                  coverImg={promo?.heroImageLink || ''}
                  altImgText={promo?.altImage}
                  tag={promo?.tag}
                  index={index}
                  handleCollectDataLayer={(data) => setCollectDataLayer((prev) => [...prev, data])}
                  classNames={''}
                  isLoadEager={hasBanner ? index < 2 : index < 4}
                  categoryEmarsys={categoryEmarsys}
                  page={page}
                  feature={feature}
                  pageTitle={pageTitle}
                  breadcrumbItems={breadcrumbItems}
                />
              );
            })}
          </div>
        </TabsPromo>

        {/* Pagination */}
        {promoList.length ? (
          <div className="flex items-center justify-center mt-6 lg:mt-9 lg:justify-between">
            <p className="hidden items-center gap-1 text-lg lg:flex">
              <span>Menampilkan</span>
              <span className="font-semibold">{promoList.length}</span>
              <span>dari</span>
              <span className="font-semibold">{totalData}</span>
            </p>

            <StaticPagination
              totalCount={totalData}
              totalPages={totalPages}
              paginationBaseUrl={paginationBaseUrl}
              pageSize={pageSize}
              feature={feature}
              breadcrumbItems={breadcrumbItems}
              emarsysData={{
                pageTitle: pageTitle,
                category: categoryEmarsys,
                page_number: page,
              }}
            />
          </div>
        ) : (
          <div className="container mt-4 lg:mt-0">
            <p className="text-sm lg:text-base">Promo tidak tersedia.</p>
          </div>
        )}
      </div>
    </section>
  );
};

PromoListSection.defaultProps = {
  categoryList: [],
  PromoList: [],
  tabClassname: 'top-[60px] lg:top-[172px] xl:top-[171px]',
};

export default PromoListSection;
